export const INVEST_NOW_MODAL_KEY = {
  OtpSend: "OTP will be sent on this number",
  termsText: " I have read, understood, and hereby accept the Privacy Policy and",
  termsLink: "Terms of use.",
  enterMobileNumber: "Please enter your mobile number",
  invalidMobileNumber: "Please enter a valid 10-digit mobile number",
  invalidMobileNumberFormat: "Please enter the valid mobile number",
  enterOtp: "Please enter the complete 4-digit OTP",
};
